import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import axios from "axios";
import { apiUrl } from "../../../constants";
import Dropdown2 from "../dropdown2/Dropdown2";

const ListSubheader2 = ({ control, register, errors }) => {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/subheadings`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentSubheading) => {
      const newOption = {
        label: currentSubheading.subheading,
        value: currentSubheading.subheading,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section>
      <div>
      <Controller
        control={control}
        name={`listSubheader`}
        render={({ field: { onChange, value } }) => (
          <Dropdown2
            label="Subheading template list"
            options={options}
            name="listSubheader"
            value={value}
            onChange={onChange}
            fieldRef={register("listSubheader", { required: true })}
          />
        )}
      />
      </div>
    </section>
  );
};

export default ListSubheader2;
